<div class="flex items-center justify-center">
  <div class="bg-white text-center rounded-lg shadow-md font-sans text-grey mx-auto my-8 p-8 max-w-xl space-y-4">
    <h2
      *ngIf="title"
      class="text-text font-bold text-xl"
    >
      {{ title }}
    </h2>
    <p
      *ngIf="message"
      class="text-lg"
    >
      {{ message }}
    </p>
  </div>
</div>
